import { useIntl } from 'react-intl'
import {
  CounterLabel,
  PlanDescriptionContainer,
  PlanDescriptionRow,
  PlanDescriptionText
} from '../../styled-component'
import { planMenuItemTypeOptions } from '../../constants'
import { formatRelativeDate } from '../../../../utils/format-relative-date'
import { useLanguageStore } from '../../../../zustand/language/use-language-store'
import { Pins, Task } from '../../../../components/stories/atoms/icons/entities'
import { iconSizeOptions } from '../../../../components/stories/atoms/icons/icons-sizes'
import PropTypes from 'prop-types'

const PlanMenuMobilePlanDescription = ({ item }) => {
  const { formatMessage } = useIntl()
  const locale = useLanguageStore.getState().locale

  if (item.type === planMenuItemTypeOptions.FOLDER) {
    return `${formatMessage({ id: 'projects_items' }, { entries: item.items })}`
  }

  return (
    <PlanDescriptionContainer>
      <PlanDescriptionRow>
        <PlanDescriptionText activeListStyle>
          {`${formatMessage({
            id: 'projects_lastActivity'
          })}: ${formatRelativeDate(item.lastActivity, locale, formatMessage)}`}
        </PlanDescriptionText>
      </PlanDescriptionRow>
      <PlanDescriptionRow>
        <PlanDescriptionText style={{ gap: '0.5rem' }}>
          {`${formatMessage({
            id: 'open'
          })}: `}

          <CounterLabel>
            <Pins size={iconSizeOptions['ICON-S']} />
            {item.openPins}
          </CounterLabel>
          <CounterLabel>
            <Task size={iconSizeOptions['ICON-S']} />
            {item.openTasks}
          </CounterLabel>
        </PlanDescriptionText>
      </PlanDescriptionRow>
    </PlanDescriptionContainer>
  )
}

PlanMenuMobilePlanDescription.propTypes = {
  item: PropTypes.object
}

export default PlanMenuMobilePlanDescription
